import {HibuTag, Span} from '../../../../search-types';

export type ClickableElementsRenderer = (clickableElements: ClickableElement[] | null) => React.JSX.Element | null;

export type HibuExtendedSpansProps = {
    hibuSpans: HibuTag[];
    renderingFunction: ClickableElementsRenderer
}

export type ClickableElement = {
    id: string;
    label: string;
    pageNumber: number;
    // The heading's full PDF-space rect, so a jump can use the same `spanToBoxPct` as the highlight
    // overlay. Carrying the span rather than single fields is what stops the two paths drifting apart.
    span: Span;
}

function orderElementsByPageAndCoordinate(a: ClickableElement, b: ClickableElement) {
    return a.pageNumber - b.pageNumber || b.span.bottomLeftY - a.span.bottomLeftY; // Coordinates are from bottom left, which means that order is reversed compared to page ordering
}

export const ClickableSectionList = (props: HibuExtendedSpansProps) => {
    if (!props.hibuSpans) {
        return null;
    }
    const clickableElements: ClickableElement[] = props.hibuSpans
        .filter(hibuSpan => hibuSpan.spans && hibuSpan.spans.length > 0 && hibuSpan.spans[0].bottomLeftY !== undefined && hibuSpan.spans[0].pageNumber !== undefined)
        .map(hibuSpan => ({
            id: hibuSpan.id,
            label: hibuSpan.label,
            // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
            pageNumber: hibuSpan.spans![0].pageNumber,
            // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
            span: hibuSpan.spans![0],
        }))
        .sort(orderElementsByPageAndCoordinate);
    return props.renderingFunction(clickableElements);
};
